/**
 * Armor of God — welcome popup auto-open behavior.
 * Shows the <modal-dialog id="ArmorPopupNewsletter"> once, after a
 * merchant-configured delay, then respects a "don't show again for N days"
 * cooldown stored in localStorage (no personal data — just a timestamp flag).
 * Never shows again in the same browser once the form has been submitted
 * successfully. Skips entirely if the customer is already logged in, since
 * they don't need to sign up for emails they already receive as an account holder.
 */
(function () {
  var STORAGE_KEY = 'armor-popup-dismissed-until';

  function shouldSkip(popup) {
    if (window.location.pathname.indexOf('/account') === 0) return true;
    if (popup.hasAttribute('data-customer-logged-in')) return true;

    var dismissedUntil = window.localStorage.getItem(STORAGE_KEY);
    if (dismissedUntil && Number(dismissedUntil) > Date.now()) return true;

    return false;
  }

  function setCooldown(days) {
    var until = Date.now() + days * 24 * 60 * 60 * 1000;
    window.localStorage.setItem(STORAGE_KEY, String(until));
  }

  function init() {
    var popup = document.getElementById('ArmorPopupNewsletter');
    if (!popup || popup.dataset.armorInitialized) return;
    popup.dataset.armorInitialized = 'true';

    var successMessage = popup.querySelector('.armor-popup__success');
    if (successMessage) {
      // Form was just submitted successfully (server re-rendered the page) —
      // show it once, then never bother this visitor again.
      setCooldown(365);
      popup.show(null);
      return;
    }

    if (shouldSkip(popup)) return;

    var delay = Number(popup.dataset.delay) || 6000;
    var frequencyDays = Number(popup.dataset.frequencyDays) || 14;

    window.setTimeout(function () {
      // Don't interrupt someone who's already deep in a cart/checkout flow.
      if (document.querySelector('cart-drawer[open]')) return;
      popup.show(null);
      setCooldown(frequencyDays);
    }, delay);

    popup.addEventListener('keyup', function (event) {
      if (event.code && event.code.toUpperCase() === 'ESCAPE') {
        setCooldown(frequencyDays);
      }
    });

    popup.querySelector('.armor-popup__close').addEventListener('click', function () {
      setCooldown(frequencyDays);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();